import { LocalDate } from '../../core/model/local-date';
import { ModelBase } from '../../core/model/model-base';
import { ESignatory } from './esignatory';

export enum ESignatureContext {
  GeneralDocument = 0,
  ApproveLeaseAgreement = 1,
  TerminateLeaseAgreement = 2,
}

export class ESignatureErrand extends ModelBase {
  constructor(dataContext?: any) {
    super();
    this.expirationDate = LocalDate.fromDate(LocalDate.today().addDays(7));
    if (dataContext) {
      this.signatories = Array.isArray(dataContext.esignatories)
        ? dataContext.signatories.map(x => Object.assign(new ESignatory(), x))
        : [];
    } else {
      this.signatories = [];
    }
  }

  private _expirationDate: LocalDate;
  get expirationDate(): LocalDate {
    return this._expirationDate;
  }
  set expirationDate(value: LocalDate) {
    this._expirationDate = LocalDate.fromDate(value);
  }

  companyId: string;
  documentCaption: string;
  document: File;
  signatories: ESignatory[];
  createdAt: Date;
  completedAt: Date;
  cancelledAt: Date;
  statusText: string;
  errandDescription: string;
  signatoriesNames: string;
  companyNumberAndName: string;
  signatureContext: ESignatureContext;
  informWhenSigned: boolean;
  informEmailAddress: string;
  currentUserEmailAddress: string;
  currentUserPhone: string;
  currentUserCivicNumber: string;
  currentUserPersonName: string;
  leaseAgreementNumber: string;

  get hasEsignatories(): boolean {
    return this.signatories && this.signatories.length > 0;
  }

  toJSON() {
    let json = Object.assign({}, this);
    json.expirationDate = this.expirationDate;
    return json;
  }
}
